import React from 'react'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import { DeveloperText, List } from './styles'
import images from '../../config/images.js'

const Menu = () => (
  <div className="w-100 flex justify-between">
    <List className="link white">
      <li>
        <FormattedHTMLMessage id="footerMenu.about"/>
      </li>
    </List>
    <div className="flex justify-center items-center">
      <div>
        <DeveloperText>
          <FormattedMessage id="footerMenu.developedBy"/>
        </DeveloperText>
        <span>
          <img src={images.anet} className="h-100" alt="anet"/>
        </span>
      </div>
    </div>
  </div>
)

export default Menu



// WEBPACK FOOTER //
// ./src/components/FooterMenu/FooterMenu.js